export default __webpack_public_path__ + "eed9fd1da429154b0a4bfc10833cf763.ttf";